"use strict";
import { useContext, useMemo } from "react";
import { AuthContext } from "./AuthContext";
export function useAuthToken() {
  const { authToken, setAuthToken } = useContext(AuthContext);
  return useMemo(() => {
    return [authToken, setAuthToken];
  }, [authToken, setAuthToken]);
}
